<template>
  <button type="button" :class="classList" @click="onClick" @keyup="onKeyUp" @blur="onBlur">
    <p-progress-linear v-if="loading" :color="loadColor" indeterminate></p-progress-linear>
    <div class="button-content">
      <slot></slot>
    </div>
  </button>
</template>

<script lang="ts">
  import interactable from '../../mixins/interactable/interactable';
  import colorable from '../../mixins/colorable/colorable';
  import loadable from '../../mixins/loadable/loadable';
  import sizeable from '../../mixins/sizeable/sizeable';
  import mixins from '../../mixins';

  export default mixins(interactable, colorable, loadable, sizeable).extend({
    props: {
      color: { default: 'interaction', type: String },
      secondary: { default: false, type: Boolean },
      tertiary: { default: false, type: Boolean },
      stretch: { default: false, type: Boolean },
      link: { default: false, type: Boolean },
    },
    data: () => ({
      navigatedUsingKeyboard: false,
    }),
    computed: {
      loadColor() {
        return this.tertiary || this.secondary ? 'text' : 'white';
      },
      classList(): Record<string, boolean> {
        return {
          'p-button': true,
          dense: this.dense,
          spacious: this.spacious,
          primary: !this.secondary && !this.tertiary,
          secondary: this.secondary,
          tertiary: this.tertiary,
          disabled: this.disabled,
          link: this.link,
          'color-interaction': this.color === undefined && !this.disabled,
          [`color-${this.color}`]: this.color !== undefined && !this.disabled && !this.secondary && !this.tertiary,
          'hover-effect': !this.disabled && !this.readonly,
          'active-effect': !this.disabled && !this.readonly,
          readonly: this.readonly,
          stretch: this.stretch,
          loading: this.loading,
          'keyboard-focus': this.navigatedUsingKeyboard,
        };
      },
    },
    methods: {
      onKeyUp() {
        this.navigatedUsingKeyboard = true;
      },
      onBlur() {
        this.navigatedUsingKeyboard = false;
      },
      onClick(event: MouseEvent) {
        if (this.disabled || this.readonly) {
          event.preventDefault();
          event.stopPropagation();
        } else {
          this.$emit('click', event);
        }
      },
    },
  });
</script>
